module.exports = __webpack_public_path__ + "static/media/K2.74cd6d40.svg";